module.exports = __webpack_public_path__ + "img/comment.b4a974e6.png";